import React from 'react'
import { ProductCollection } from '../../Components/ProductCollection/ProductCollection';
import { Footer } from '../../Components/Footer/Footer';

 const ProductsPage = () => {
  return (
    <div>
      <ProductCollection />
      <Footer />  
    </div>
  )
}
 
export default ProductsPage;